<template>
	<main class="min-h-fit">
		<GenericB2CLandingPage
			:questions="questions || []"
			:results="results"
			:quiz-id="quizId"
			:articles="articles || []"
			:content="quizTexts"
			:yes-or-no-quiz="false"
			weighted-quiz
			shuffled-answers
		/>
	</main>
</template>

<script lang="ts">
import type { IAPIArticle } from '@hokify/magazine-interface';
import { mapStores } from 'pinia';
import { getCanonicalUrl } from '~/helpers/metadata';
import GenericB2CLandingPage from '~/components/website/GenericB2CLandingPage.vue';
import quizTexts from '~/data/b2c-lps/quizzes/lehre-quiz.json';
import { useQuizStore } from '@/stores/quiz';
import { useMagazineStore } from '@/stores/magazine';
import { useRootStore } from '@/stores/root';

export default defineNuxtComponent({
	name: 'LehreQuiz',
	components: { GenericB2CLandingPage },

	validate({ $pinia }) {
		const rootStore = useRootStore($pinia);
		return rootStore.topLevelDomain === 'at';
	},
	setup() {
		definePageMeta({
			layout: 'default',
			meta: {
				includedTopLevelDomains: ['at']
			}
		});

		defineRouteRules({ includedTopLevelDomains: ['de'] });

		const rootStore = useRootStore();
		const path = `${rootStore.host}/lp/${quizTexts.path}`;
		const canonical = getCanonicalUrl(path);

		const result: any = {
			title: `${quizTexts.metaTitle}`,
			link: [canonical],
			meta: [
				{ name: 'robots', content: 'index, follow' },
				{
					name: 'description',
					content: quizTexts.metaDescription
				}
			]
		};

		useHead(result);
	},
	computed: {
		...mapStores(useRootStore)
	},
	async asyncData({ $pinia }) {
		const quizStore = useQuizStore($pinia);
		const magazineStore = useMagazineStore($pinia);

		try {
			const [{ articles }, quiz] = await Promise.all([
				magazineStore.loadArticlesByAliases({
					aliases: quizTexts.articles.slice(0, 3)
				}),
				quizStore.loadQuestions({
					quizType: `${quizTexts.siteType}`
				})
			]);

			return { articles, questions: quiz.questions, results: quiz.results, quizId: quiz._id };
		} catch (err: any) {
			throw createError(err ?? 'Error not defined');
		}
	},
	data() {
		const quizId = undefined as string | undefined;
		const results = undefined as { title: string; text: string }[] | undefined;
		const articles = undefined as IAPIArticle[] | undefined;
		const questions = undefined as
			| {
					_id: string;
					question: string;
					options: {
						correct: boolean;
						explanation: string;
						option: string;
						totalAnswers: number;
					}[];
			  }[]
			| undefined;

		return {
			questions,
			articles,
			results,
			quizId,
			quizTexts
		};
	}
});
</script>
